import React, { useContext } from 'react';
import AddElementButton from './Elements/AddElementButton';
import { ContextBuilder } from '../../context/builder/reducers';
import MoveButton from './Elements/MoveButton';
import DeleteButton from './Elements/DeleteButton';
import SliderImage from './Elements/SliderImage';
import LastProjects from './Elements/LastProjects';
import DirectionActivity from './Elements/DirectionActivity';
import AboutUs from './Elements/AboutUs';
import OurClients from './Elements/OurClients'
import Header from './Elements/Header';
import SliderImageAboutUs from './Elements/SliderImageAboutUs';
import SliderImageVacancy from './Elements/SliderImageVacancy';
import Awards from './Elements/Awards';
import OurTeam from './Elements/OurTeam';
import ImgTitle from './Elements/ImgTitle';
import BestServices from './Elements/BestServices';
import IndustrialPlatform from './Elements/IndastrialPlatform';
import Partners from './Elements/Partners';
import TinyMce from './Elements/TinyMce';
import CareerTextBlock from './Elements/CareerTextBlock';
import Projects from './Elements/Projects';
import IconsList from './Elements/IconsList';
import SimpleList from './Elements/SimpleList';
import Params from './Elements/Params';
import SelectedEmployees from './Elements/SelectedEmployees';
import VacancyTextBlock from './Elements/VacancyTextBlock';
import VacancyDescription from './Elements/VacancyDescription';

const Builder = () => {
    const { state } = useContext(ContextBuilder);

    const allowedElements = [
        {
            category: 'Общие',
            elements: [
                { type: 'simple-list', name: 'Simple list', description: 'Simple list', img: null },
                { type: 'article-text', name: 'Текст', description: 'Text in the Article', img: '' },
                { type: 'slider-image', name: 'Slider image main page', description: 'Slider image', img: null },
                { type: 'last-projects', name: 'Last projects', description: 'Block with projects', img: null },
                { type: 'last-articles', name: 'Last articles', description: 'Block with latest articles', img: null },
                { type: 'selected-employees', name: 'Selected employees', description: 'Selected employees', img: null },
                { type: 'params', name: 'Params', description: 'Params', img: null },
                {
                    type: 'direction-activity',
                    name: 'Direction activity',
                    description: 'Block with direction activity, img: null'
                },
                { type: 'about-us', name: 'About us', description: 'Block about us', img: null },
                { type: 'our-clients', name: 'Our clients', description: 'Block with our clients', img: null },
                { type: 'header-about-us', name: 'Header about us', description: 'Header about us', img: null },
                {
                    type: 'slider-image-about-us',
                    name: 'Slider image about us',
                    description: 'Slider image in about us'
                },
                { type: 'awards', name: 'Awards', description: 'Awards', img: null },
                { type: 'feedback-about-us', name: 'Feedback', description: 'Feedback', img: null },
                { type: 'our-team', name: 'Our team', description: 'Our team', img: null },
                { type: 'call-action', name: 'Call to action', description: 'Call to action', img: null },
                { type: 'header-service', name: 'Header service', description: 'Header service', img: null },
                { type: 'best-services', name: 'Best services', description: 'Best services', img: null },
                { type: 'projects', name: 'Projects', description: 'Our projects', img: null },
                { type: 'recommendations', name: 'Recommendations', description: 'Recommendations', img: null },
                {
                    type: 'industrial-platform',
                    name: 'Industrial platform',
                    description: 'Industrial platform',
                    img: null
                },
                { type: 'partners', name: 'Partners', description: 'Partners', img: null },
                {
                    type: 'slider-image-vacancy',
                    name: 'Slider image vacancy',
                    description: 'Slider image vacancy',
                    img: null
                },
                { type: 'icons-list', name: 'Icons list', description: 'List with icons', img: null },
                { type: 'all-projects', name: 'All projects', description: 'All projects', img: null },
            ]
        },
        {
            category: 'Команда',
            elements: [
                { type: 'team', name: 'Team', description: 'Team', img: null }
            ]
        },
        {
            category: 'Контакты',
            elements: [
                { type: 'contact-form', name: 'Contact form', description: 'Форма на странице контактов', img: null }
            ]
        },
        {
            category: 'Сервисы',
            elements: [
                { type: 'services', name: 'Services', description: 'Block with services', img: null }
            ]
        },
        {
            category: 'Карьера',
            elements: [
                { type: 'career-text-block', name: 'Career text block', description: 'Career text block', img: null },
                { type: 'career-img', name: 'Career image', description: 'Career image', img: null },
                { type: 'career-form', name: 'Career form', description: 'Career form', img: null },
                { type: 'vacancy-text-block', name: 'Vacancy text block', description: 'Vacancy text block', img: null },
                { type: 'vacancy-description', name: 'Vacancy description', description: 'Vacancy description', img: null }
            ]
        }
    ];

    const getElement = (element, index) => {
        switch (element.type) {
            case 'slider-image':
                return <SliderImage index={index} content={element.content}/>;
            case 'last-projects':
                return <LastProjects index={index} content={element.content}/>;
            case 'last-articles':
                return <div><h2>Last articles</h2></div>;
            case 'direction-activity':
                return <DirectionActivity index={index} content={element.content}/>;
            case 'about-us':
                return <AboutUs index={index} content={element.content}/>;
            case 'our-clients':
                return <OurClients index={index} content={element.content}/>;
            case 'header-about-us':
                return <Header index={index} content={element.content}/>;
            case 'slider-image-about-us':
                return <SliderImageAboutUs index={index} content={element.content}/>;
            case 'awards':
                return <Awards index={index} content={element.content}/>;
            case 'feedback-about-us':
                return <div><h2>Feedback block</h2></div>;
            case 'our-team':
                return <OurTeam index={index} content={element.content}/>;
            case 'call-action':
                return <div><h2>Call to action</h2></div>;
            case 'header-service':
                return <ImgTitle index={index} content={element.content}/>;
            case 'best-services':
                return <BestServices index={index} content={element.content}/>;
            case 'projects':
                return <Projects index={index} content={element.content}/>;
            case 'industrial-platform':
                return <IndustrialPlatform index={index} content={element.content}/>;
            case 'partners':
                return <Partners index={index} content={element.content}/>;
            case 'article-text':
                return <TinyMce
                    key={`tiny_${index}`}
                    id={`tiny_${element.id}`}
                    value={element.content}
                    background={element.background}
                    index={index}
                    name="content"
                />;
            case 'slider-image-vacancy':
                return <SliderImageVacancy index={index} content={element.content}/>;
            case 'career-text-block':
                return <CareerTextBlock title="Career text block" index={index} content={element.content}/>;
            case 'career-img':
                return <ImgTitle title="Career img" index={index} content={element.content}/>
            case 'career-form':
                return <div><h2>Career form</h2></div>;
            case 'recommendations':
                return <div><h2>Recommendations</h2></div>;
            case 'team':
                return <div><h2>Team</h2></div>;
            case 'contact-form':
                return <div><h2>Contact form</h2></div>;
            case 'services':
                return <div><h2>Services</h2></div>;
            case 'icons-list':
                return <IconsList index={index} content={element.content} />
            case 'all-projects':
                return <div><h2>All projects</h2></div>
            case 'simple-list':
                return <SimpleList index={index} content={element.content} />;
            case 'params':
                return <Params index={index} content={element.content} />;
            case 'selected-employees':
                return <SelectedEmployees index={index} content={element.content} />
            case 'vacancy-text-block':
                return <VacancyTextBlock index={index} content={element.content} />
            case 'vacancy-description':
                return <VacancyDescription index={index} content={element.content} />;
            default:
                throw new Error(`Element ${element.type} not found`);
        }
    };

    const elements = () => {
        return state.data.value.map((element, index) =>
            <div key={element.id} className="element">
                <div className="item">
                    <div className="content">
                        {getElement(element, index)}
                    </div>
                    <div className="controls">
                        <MoveButton
                            onClick={() => {
                            }}
                            currentIndex={index}
                            newIndex={index - 1}
                            total={state.data.value.length}
                        />

                        <DeleteButton index={index}/>

                        <MoveButton
                            currentIndex={index}
                            newIndex={index + 1}
                            total={state.data.value.length}
                        />
                    </div>
                </div>
                <AddElementButton allowedElements={allowedElements} index={index + 1}/>
            </div>
        );
    };

    return (
        <div>
            <AddElementButton allowedElements={allowedElements} index={0}/>
            {elements()}
            <div className="mt-4" style={{ display: 'none' }}>
        <textarea
            name={state.data.name}
            value={JSON.stringify(state.data.value)}
            readOnly
            className="form-control"
            rows="10"
        ></textarea>
            </div>
        </div>
    );
};

export default Builder;
